import React, { useContext, useRef, useState } from "react";
import Swal from "sweetalert2";
import { SettingsContext } from "../context";
import "../style/ProductImage.css";
import api from "../context/api";

const ProductImage = () => {
    const {imageList,
        setImageList,
        id
    } =useContext(SettingsContext);
  const fileInputRef = useRef(null);
  const [newImages, setNewImages] = useState([]);

  const openFileInput = () => {
    fileInputRef.current.click();
  };

  const addImages = (e) => {
    const files = Array.from(e.target.files);
    const readers = files.map((file) => {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          resolve({ name: file.name, src: event.target.result, file });
        };
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readers).then((images) => {
      setNewImages((prev) => [...prev, ...images]);
    });
  };

  const removeExistingImage = (url) => {
    Swal.fire({
      title: "Bu görseli silmek istiyor musunuz?",
      showCancelButton: true,
      confirmButtonText: "Evet",
    }).then((result) => {
      if (result.isConfirmed) {
        setImageList((prev) => prev.filter((img) => img !== url));
      }
    });
  };

  const removeNewImage = (name) => {
    Swal.fire({
      title: "Eklenen bu resmi silmek istiyor musunuz?",
      showCancelButton: true,
      confirmButtonText: "Evet",
    }).then((result) => {
      if (result.isConfirmed) {
        setNewImages((prev) => prev.filter((img) => img.name !== name));
      }
    });
  };

  const moveImage = (index, direction, isNew) => {
    const arr = isNew ? [...newImages] : [...imageList];
    const targetIndex = direction === "left" ? index - 1 : index + 1;

    if (targetIndex < 0 || targetIndex >= arr.length) return;

    [arr[index], arr[targetIndex]] = [arr[targetIndex], arr[index]];

    isNew ? setNewImages(arr) : setImageList(arr);
  };

  const sendImages = () => {
    const formData = new FormData();
    newImages.forEach((img) => formData.append("files", img.file));
    formData.append("urls",imageList);    
    api.sendImages(id,formData).then(() => {
      Swal.fire("Başarılı", "Görseller kaydedildi", "success");
    });
  };

  return (
    <div className="image-controls">
      <button className="saveButton" onClick={openFileInput}
                  style={{ margin: 5, backgroundColor: "blue",fontSize:"20px" }}
>
        📷 Resim Ekle
      </button>
      <input
        type="file"
        ref={fileInputRef}
        onChange={addImages}
        style={{ display: "none" }}
        multiple
        accept="image/*"
      />
      <button className="saveButton" onClick={sendImages}
                  style={{ margin: 5,  backgroundColor: "green" ,fontSize:"20px"}}
>
        💾 Kaydet
      </button>

      <div className="selectedImage" data-id={id}>
        {imageList?.map((url, index) => (
          <div key={url} className="zoom">
            <img className="smallImage" src={url} alt={`Ürün resmi ${index + 1}`} />
            <button
              className="order-btn order-left"
              onClick={() => moveImage(index, "left", false)}
              title="Sola taşı"
            >
              ◀
            </button>
            <button
              className="order-btn order-right"
              onClick={() => moveImage(index, "right", false)}
              title="Sağa taşı"
            >
              ▶
            </button>
            <button
              className="remove-btn"
              onClick={() => removeExistingImage(url)}
              title="Sil"
            >
              ✕
            </button>
          </div>
        ))}

        {newImages.map((img, index) => (
          <div key={img.name} className="zoom" data-is-file="yes" data-name={img.name}>
            <img className="smallImage" src={img.src} alt={img.name} />
            <button
              className="order-btn order-left"
              onClick={() => moveImage(index, "left", true)}
              title="Sola taşı"
            >
              ◀
            </button>
            <button
              className="order-btn order-right"
              onClick={() => moveImage(index, "right", true)}
              title="Sağa taşı"
            >
              ▶
            </button>
            <button
              className="remove-btn"
              onClick={() => removeNewImage(img.name)}
              title="Sil"
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductImage;
